import styled from 'styled-components';

export const ReportRewardContainerStyled = styled.div`
  .loading_show {
    width: 100%;
    height: calc(100vh - 100px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top_sec {
    margin-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ts_left_col {
      font-size: ${({ theme }) => theme.FONT.SIZE.S20};
      font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
      color: ${({ theme }) => theme.COLORS.BLACK_1};
    }
    .ts_right_col {
      width: 188px;
      height: 46px;
      flex-shrink: 0;
    }
  }
  .filter_wrap {
    margin-bottom: 18px;
  }
  .m_report_container {
    width: 95vw;
    height: 90vh;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
  }
`;
